(function () {
  function initCountdown(root) {
    var end = root.getAttribute('data-countdown-end');
    if (!end) return;

    var endTime = Date.parse(end);
    if (Number.isNaN(endTime)) return;

    var units = {
      days: root.querySelector('[data-unit="days"]'),
      hours: root.querySelector('[data-unit="hours"]'),
      minutes: root.querySelector('[data-unit="minutes"]'),
      seconds: root.querySelector('[data-unit="seconds"]')
    };

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function tick() {
      var diff = Math.max(0, endTime - Date.now());
      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (units.days) units.days.textContent = pad(days);
      if (units.hours) units.hours.textContent = pad(hours);
      if (units.minutes) units.minutes.textContent = pad(minutes);
      if (units.seconds) units.seconds.textContent = pad(seconds);
    }

    tick();
    window.setInterval(tick, 1000);
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;

    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    var step = track.querySelector('.cdg-home-product, .cdg-product-card')?.offsetWidth || 320;

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -(step + 16), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step + 16, behavior: 'smooth' });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cdg-countdown]').forEach(initCountdown);
    document.querySelectorAll('[data-cdg-carousel]').forEach(initCarousel);
  });
})();
